module.exports = __webpack_public_path__ + "img/HU.456f4b1b.svg";